import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitMargins } from '../../SkeletonUnit.h'

export interface ICategoriesTabsSkeletonUnitProps extends ISkeletonUnitProps {}

export const CategoriesTabsSkeletonUnit = ({
  height = '42px',
  margins = SkeletonUnitMargins.SIZE_10,
  ...rest
}: ICategoriesTabsSkeletonUnitProps): JSX.Element => (
  <SkeletonUnit height={height} margins={margins} {...rest} />
)
